import { Pipe, PipeTransform } from '@angular/core';

import { ImageResponse } from '@app/api/marketplace/models';

@Pipe({
  name: 'defaultImage',
})
export class DefaultImagePipe implements PipeTransform {
  transform(images: ImageResponse[], imageBaseUrl: string): string {
    if (!images?.length) {
      return '#dcdcdc';
    }
    let idx = images.findIndex((image) => image.isDefault) ?? 0;
    return `url(${imageBaseUrl}/${images[idx].smallUrl}) center no-repeat`;
  }
}
